module.exports = __webpack_public_path__ + "img/jylnicon4.6fb1d7ca.jpg";